<template>
  <DpaNewsBaseModal
    ref="modal"
    :is-loading="isFetching"
    :submit-button-label="t('control.delete')"
    :has-close-button="false"
    tracking-place="deleteSaveSearch"
    @submit="handleDeleteSaveSearch"
    @cancel.prevent>
    <template #header>{{ t("control.delete") }}</template>
    <p class="py-4 text-base">
      {{ t("savedSearches.confirmDelete", { searchName }) }}
    </p>
  </DpaNewsBaseModal>
</template>

<script setup lang="ts">
import { toRef, useTemplateRef } from "vue";
import { useI18n } from "vue-i18n";

import DpaNewsBaseModal from "@/components/shared/DpaNewsBaseModal/DpaNewsBaseModal.vue";
import { useDeleteSavedSearch } from "@/composition/api/savedSearches.ts";
import { handleLocalError } from "@/utils/errorHandling.ts";

const { t } = useI18n();
const props = defineProps<{
  searchName: string;
  searchColor: string;
  searchId: string;
}>();
const urn = toRef(props, "searchId");

const emit = defineEmits<{
  deleted: [];
}>();

const modal = useTemplateRef<InstanceType<typeof DpaNewsBaseModal>>("modal");

const {
  execute: deleteSavedSearch,
  isFetching,
  error: deleteSearchError,
} = useDeleteSavedSearch(urn);

const handleDeleteSaveSearch = async () => {
  await deleteSavedSearch();
  window.Appcues?.track?.("Saved search deleted");
  if (deleteSearchError.value) {
    handleLocalError(
      deleteSearchError.value.status,
      t("errors.deleteSaveSearch.failed"),
    );
    return;
  }

  emit("deleted");
  requestClose();
};

function showModal() {
  modal.value?.showModal();
}

function requestClose() {
  modal.value?.requestClose();
}

function close() {
  modal.value?.close();
}

defineExpose({ showModal, close, requestClose });
</script>
